
export const FETCH_FEE_DATA_BEGIN = 'FETCH_FEE_DATA_BEGIN';
export const FETCH_FEE_DATA_SUCCESS = 'FETCH_FEE_DATA_SUCCESS';
export const FETCH_FEE_DATA_FAILURE = 'FETCH_FEE_DATA_FAILURE';

